import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { delay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AreaInsertRequest } from '../component/area-insert/area-insert-request';
import { CategoryItem } from '../component/client-detail/category-item';
import { SenderAnagraficaUpdateRequest } from '../component/client-detail/sender-anagrafica-update-request';
import { SenderAreasUpdateRequest } from '../component/client-detail/sender-areas-update-request';
import { SenderCategoriesUpdateRequest } from '../component/client-detail/sender-categories-update-request';
import { AreaInsertByGeojsonRequest } from '../component/show-areas/area-insert-by-geojson-request';
import { SenderInsertRequest } from '../component/show-clients/sender-insert-request';
import { ServiceInsertRequest } from '../component/show-services/service-insert-request';
import { UserInsertRequest } from '../component/show-users/user-insert-request';
import { UserModifyRequest } from '../component/show-users/user-modify-request';
import { UserModifySendersRequest } from '../component/show-users/user-modify-senders-request';
import { Area } from '../model/area';
import { Category } from '../model/category';
import { Message } from '../model/message';
import { Pageable2 } from '../model/pageable2';
import { Sender } from '../model/sender';

@Injectable({
  providedIn: 'root'
})
export class AdminService {

  static DELAY_TIME = 2000;

  constructor(private http: HttpClient,) { }

  // getMessage(id: string): Observable<Message> {
  //   return this.http.get<Message>(`${environment.baseUrl}/v4/aop/messages/${id}`);
  // }

  getSenders(): Observable<Sender[]> {
    return this.http.get<Sender[]>(`${environment.baseUrl}/v4/aop/senders`);
  }

  getSendersPaginated(pageable: Pageable2): Observable<any> {
    return this.http.post<any>(`${environment.baseUrl}/v4/aop/senders/filtering`, pageable);
  }

  getSenderDetail(id: number): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl}/v4/aop/senders/details/${id}`);
  }

  getAreaDetail(id: number): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl}/v4/aop/area/${id}`);
  }

  insertSender(senderInsertRequest: SenderInsertRequest): Observable<any> {
    return this.http.put<any>(`${environment.baseUrl}/v4/aop/senders`, senderInsertRequest)
      .pipe(delay(AdminService.DELAY_TIME));
  }

  insertUser(userInsertRequest: UserInsertRequest): Observable<any> {
    return this.http.post<any>(`${environment.baseUrl}/v4/aop/user/create`, userInsertRequest)
      .pipe(delay(AdminService.DELAY_TIME));
  }

  insertArea(areaInsertRequest: AreaInsertRequest): Observable<any> {
    return this.http.put<any>(`${environment.baseUrl}/v4/aop/geo/coords/create`, areaInsertRequest)
      .pipe(delay(AdminService.DELAY_TIME));
  }

  insertAreaByGeojson(areaInsertByGeojsonRequest: AreaInsertByGeojsonRequest): Observable<any> {
    return this.http.put<any>(`${environment.baseUrl}/v4/aop/geo/create`, areaInsertByGeojsonRequest)
      .pipe(delay(AdminService.DELAY_TIME));
  }

  insertService(serviceInsertRequest: ServiceInsertRequest): Observable<any> {
    return this.http.put<any>(`${environment.baseUrl}/v4/aop/services/create`, serviceInsertRequest)
      .pipe(delay(AdminService.DELAY_TIME));
  }

  updateService(serviceInsertRequest: ServiceInsertRequest): Observable<any> {
    return this.http.put<any>(`${environment.baseUrl}/v4/aop/services/update`, serviceInsertRequest)
      .pipe(delay(AdminService.DELAY_TIME));
  }

  deleteService(id){
    return this.http.delete(`${environment.baseUrl}/v4/aop/services/${id}`)
  }

  modifyUser(userModifyRequest: UserModifyRequest): Observable<any> {
    return this.http.put<any>(`${environment.baseUrl}/v4/aop/user/update`, userModifyRequest)
      .pipe(delay(AdminService.DELAY_TIME));
  }

  modifyUserSenders(userModifySendersRequest: UserModifySendersRequest): Observable<any> {
    return this.http.put<any>(`${environment.baseUrl}/v4/aop/users/update/senders`, userModifySendersRequest)
      .pipe(delay(AdminService.DELAY_TIME));
  }

  /**
   * @deprecated
   */
  updateSenderDetail(senderDetail: any): Observable<any> {
    return this.http.put<any>(`${environment.baseUrl}/v4/aop/senders/update`, senderDetail)
      .pipe(delay(AdminService.DELAY_TIME));
  }

  updateSenderAnagrafica(senderAnagrafica: SenderAnagraficaUpdateRequest): Observable<any> {
    return this.http.put<any>(`${environment.baseUrl}/v4/aop/senders/update/anagrafica`, senderAnagrafica);
  }

  updateSenderCategories(senderCategories: SenderCategoriesUpdateRequest): Observable<any> {
    return this.http.put<any>(`${environment.baseUrl}/v4/aop/senders/update/categories`, senderCategories);
  }

  updateSenderAreas(senderAreas: SenderAreasUpdateRequest): Observable<any> {
    return this.http.put<any>(`${environment.baseUrl}/v4/aop/senders/update/areas`, senderAreas);
  }

  getAllCategories(): Observable<CategoryItem[]> {
    return this.http.get<CategoryItem[]>(`${environment.baseUrl}/v4/aop/senders/categories`);
  }

  getAllAreas(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.baseUrl}/v4/aop/senders/areas`);
  }

  getAllSenders(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.baseUrl}/v4/aop/senders/essential`);
  }

  getAllUserSenders(id: number): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl}/v4/aop/user/senders/${id}`);
  }

  getAllServices(): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl}/v4/aop/services`);
  }

  getAllUsers(): Observable<any> {
    return this.http.get<any>(`${environment.baseUrl}/v4/aop/users_role`);
  }

  getUsers(pageable: Pageable2): Observable<any> {
    return this.http.post<any>(`${environment.baseUrl}/v4/aop/users/filtering`, pageable);
  }

  disableUser(disableUserRequest: any): Observable<any> {
    return this.http.put<any>(`${environment.baseUrl}/v4/aop/user/suspend`, disableUserRequest);
  }

  enableUser(disableUserRequest: any): Observable<any> {
    return this.http.put<any>(`${environment.baseUrl}/v4/aop/user/activate`, disableUserRequest);
  }

  deleteUser(idUser: number): Observable<any> {
    return this.http.delete<any>(`${environment.baseUrl}/v4/aop/users/${idUser}`);
  }

}
